import * as http from '../http'
import * as Types from './types'

export default class ManagersGateway {
  managersRemoveFromTag (query = {}) {
    return http.POST(Types.MANAGERS_REMOVE_FROM_TAG, query)
  }

  move (query = {}) {
    return http.POST(Types.MANAGERS_MOVE, query)
  }

  delete (query = {}) {
    return http.DELETE(Types.MANAGERS_DELETE, {}, query)
  }

  add (query = {}) {
    return http.POST(Types.MANAGERS_ADD, query)
  }

  update (query = {}) {
    return http.POST(Types.MANAGERS_UPDATE, query)
  }

  assignEmployee (query = {}) {
    return http.POST(Types.MANAGERS_ASSIGN_EMPLOYEE, query)
  }

  assignEmployees (query = {}) {
    return http.POST(Types.MANAGERS_ASSIGN_EMPLOYEES, query)
  }

  removeEmployee (query = {}) {
    return http.DELETE(Types.MANAGERS_REMOVE_EMPLOYEE, {}, query)
  }

  removeEmployees (query = {}) {
    return http.POST(Types.MANAGERS_REMOVE_EMPLOYEES, query)
  }

  moveEmployee (query = {}) {
    return http.POST(Types.MANAGERS_MOVE_EMPLOYEE, query)
  }

  moveEmployees (query = {}) {
    return http.POST(Types.MANAGERS_MOVE_EMPLOYEES, query)
  }

  removeTag (query = {}) {
    return http.POST(Types.MANAGERS_REMOVE_TAG, query)
  }

  assignTag (query = {}) {
    return http.POST(Types.MANAGERS_ASSIGN_TAG, query)
  }

  getManagers () {
    return http.GET(Types.MANAGERS_END_POINT)
  }

  getManagersList () {
    return http.GET(Types.MANAGERS_LIST_END_POINT)
  }

  getManagersChildrenById (params = {}) {
    return http.GET(Types.MANAGERS_CHILDREN_END_POINT, params)
  }

  managersExportExcel () {
    return http.POSTEXPORT(Types.MANAGERS_EXPORT_EXCEL)
  }

  uploadManagers (query = {}) {
    return http.POSTUPLOAD(Types.UPLOAD_MANAGERS_END_POINT, query)
  }

  uploadManagersAppend (query = {}) {
    return http.POSTUPLOAD(Types.MANAGERS_UPLOAD_APPEND, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/managers/ManagersGateway.js